import { Job } from './job';
export class Project {
    public id: string;
    public userId: string;
    public companyId: string;
    public sharingKey: string;

    public name: string;
    public description: string;
    public creationDate: Date;
    public archived: boolean;
    public jobs: Array<Job>;

    constructor();
    constructor(projectJson: any, jobs: any);
    constructor(projectJson?: any, jobs?: any) {
        if (projectJson) {
            this.id = projectJson.id;
            this.userId = projectJson.userId;
            this.companyId = projectJson.companyId;
            this.sharingKey = projectJson.sharingKey;

            this.name = projectJson.name;
            this.description = projectJson.description;
            this.creationDate = projectJson.creationDate;
            this.archived = projectJson.archived;
        }
        if (jobs) {
            this.jobs = jobs.map((jobJson: any) => new Job(jobJson));
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/modules/domain/models/project.ts